import { render, staticRenderFns } from "./AddNewAvoirModal.vue?vue&type=template&id=1f3c5532&"
import script from "./AddNewAvoirModal.vue?vue&type=script&lang=js&"
export * from "./AddNewAvoirModal.vue?vue&type=script&lang=js&"
import style0 from "./AddNewAvoirModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports